/**
 * @auth 赖传峰
 * @date 2022/4/25
 */

import {
  computed,
  useNuxtApp,
} from '#imports'

export default (title: string) => {
  const { t } = useNuxtApp().$i18n
  return computed(() => `${title} | PikPak - ${t('title-suffix')}`)
}
